export const GetUrl = {
  getApplicationAll: "application/all_applications",
  getApplication: "application/existing_application",
  applicationStatusCheck: "application/application_status",
  getSasToken: "utils/sas_token",
  getSasTokenFile: "utils/sas_token_for_file_download",
  getFundHistory: "fund/payment-history",
  getAllFund: "fund/fund-management",
  getScholarshipSummary: "scholarship",
  getExpenseSummary: "expense",
  getExpenseSummaryDetails: "expense/expense-details",
  getOngoingEvaluation: "evaluation/ongoing-evaluation",
  getEvaluationByScholarshipId: "evaluation/scholarship",
  getFundAllocationList: "fund",
  getUser: "user",
  getApplicationDropdown: "application/dropdown-data",
  getDashboard: "dashboard/",
  getSearch: "search",
  getEmailVerify: "auth/verify-email",
  getReport: "reports/payment_forecast",
  getSpentReport: "reports/spend_report",
  getUserGrowthReport: "reports/user_growth",
  getAttendance: "utils/attendance",
}; 
export const PostUrl = {
  refreshToken: "auth/refresh-token",
  createApplication: "application/create_application",
  createApplicationDetails: "application/application_details",
  intialApplication: "application/intiate_application",
  postAdditionalDocuments: "application/additional_documents",
  postApplicationSubmit: "application/application_submit",
  postFund: "fund",
  scholarshipStatus: "scholarship",
  postExpense: "expense/expense-details",
  postEvaluation: "evaluation/ongoing-evaluation",
  auth: "auth/login",
  postAuthInitiateMobileVerification: "auth/initiate-mobile-verification",
  postAuthVerifyMobile: "auth/verify-mobile",
  postAuthResendOtp: "auth/resend-otp",
  postAuthVerifyPhoneNumber: "auth/verify-phone-number",
  postChangePassword: "auth/change-password",
  emailOtp: "auth/email-otp",
  forgetPassword: "auth/forget-password",
  postAttendance: "utils/attendance",
};

export const PatchUrl = {
  updateApplicationDetails: "application/update_application",
  updateStatus: "application/update_application_status",
  updateUser: "user",
  updateScholarshipFund: "scholarship/fund-allocation",
  patchFund: "fund",
};

export const DeleteUrl = {
  deleteDocApplication: "application/document",
  deleteDocUser:"user/document",
  deleteApplicationRow: "application/application_data",
  deleteBankRow: "user/bank_details",
  deleteFundPayment: "fund",
};

export const configWithToken = {
  headers: { "Content-Type": "application/json", "Require-Token": true },
};
export const configWithUrlencodedToken = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    "Require-Token": true,
  },
};
export const configWithCustomToken = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    "Custom-Token": true,
  },
};
export const configNotCustomToken = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    "Require-Token": false,
  },
};
export const configNotToken = { headers: { "Require-Token": false } };

export const configBlobToken = {
  headers: {
    "x-ms-blob-type": "BlockBlob",
    "Content-Type": "image/jpeg",
  },
};

export const configPutHeader = (file: File) => ({
  headers: {
    "x-ms-blob-type": "BlockBlob",
    "Content-Type": file.type || "application/octet-stream",
  },
});
